
window.timer = function(name) {
  var start = new Date();
  return {
    stop: function() {
      var end = new Date();
      var time = end.getTime() - start.getTime();
      window.console.log('Timer:', name, 'finished in', time, 'ms');
    }
  }
};

window.isMobile = function(){

	if(window.navigator.userAgent.match(/Android/i)) return true;
	if(window.navigator.userAgent.match(/iPhone|iPad/i)) return true;
	return false;


}

window.favicon = function(url){
  var match;
  if(url.match(/mail\.google\.com|gmail\.com/)) return 'https://ssl.gstatic.com/ui/v1/icons/mail/images/favicon5.ico';
  if(url.match(/google\.com\/drive|drive\.google\.com/)) return 'https://ssl.gstatic.com/docs/doclist/images/infinite_arrow_favicon_5.ico';
  if(url.match(/google\.com\/sheets|docs\.google\.com\/spreadsheets/)) return 'https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico';
  if(url.match(/google\.com\/docs|docs\.google\.com/)) return 'https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico';
  if(match = url.match(/youtube\.com\/watch\?v=([0-9a-zA-Z_.-]+)/)) return 'https://img.youtube.com/vi/'+match[1]+'/default.jpg';
  if(match = url.match(/youtu\.be\/([0-9a-zA-Z_.-]+)/)) return 'https://img.youtube.com/vi/'+match[1]+'/default.jpg';

  return "https://api.scaalar.com/favicon.php?url="+url;
  // var host = url.match(/(https?:\/\/[^/]+)/).pop();
  // return host+'/favicon.ico';
}

window.bodyTheme = function(theme){
  document.querySelector('body').className = document.querySelector('body').className.replace(/tema\d+/,'');
  //  document.querySelector('body').classList.add(this.preferences.tema);
  if(theme) document.querySelector('body').className+=' '+theme;
}


window.uniqid = function(prefix){
  var str = ''
  if(prefix) str = prefix;
  var charcode = Math.floor(Math.random() * 26) + 97; // a-z
  str+=String.fromCharCode(charcode);
  str+=Math.floor(Math.random() * 1000000);
  str+=new Date().getTime()
  return str;
}

window.getCookie = function(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


window.setCookie = function(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.urlinks.com.br;path=/";
}


window.askRegisterAnonymous = function(state) {
  console.log('seconds since last login',Math.round(new Date().getTime()/1000)-state.user.lastLogin);
  if(state.user.isAnonymous && !state.skipRegistrar){
    if(state.user.lastLogin && Math.round(new Date().getTime()/1000)-state.user.lastLogin>120){
      return true;
    }
  }
  return false;
}
